import { createSelector } from 'reselect'
import * as siteSelectors from 'services/site/selectors'

export const selectUserRoutes = (state) => state.routes.userRoutes
export const selectNoUserRoutesFound = (state) => state.routes.noUserRoutesFound

// route print
export const selectRoute = (state) => state.routes.route

export const selectPoints = createSelector(
  selectRoute,
  (route) => route && route.points
)

export const selectNotes = createSelector(
  selectPoints,
  (points) => {
    if (!points) { return }
    return points
      .filter((p) => p.hasOwnProperty('notes'))
      .map((p) => p.notes)
  }
)

function removeStyleAttribute (str) {
  return str.replace(/style="[^\"]*"/, '')
}

export const selectDirections = createSelector(
  selectNotes,
  (notes) => {
    const directions = []
    let distanceAccumulator = 0
    notes && notes.forEach((note) => {
      note.split('~').forEach((segment) => {
        const _stripped = removeStyleAttribute(segment)
        const tokens = _stripped.split(':')
        if (tokens.length < 3) { return }
        const [text, , , distance] = tokens
        directions.push({ text, distance: distanceAccumulator })
        distanceAccumulator = distanceAccumulator + Number(distance)
      })
    })

    if (directions.length > 0) {
      directions.push({ text: 'Destination', distance: distanceAccumulator })
    }

    return directions
  }
)

// route search
export const selectGoogleMapsLoaded = (state) => state.routes.googleMapsLoaded
export const selectLocationSuggestions = (state) => state.routes.locationSuggestions
export const selectFormattedUserCoords = (state) => state.routes.formattedUserCoords
export const selectSearchCoords = (state) => state.routes.searchCoords
export const selectSearchLoading = (state) => state.routes.searchLoading
export const selectSearchResults = (state) => state.routes.searchResults
export const selectSearchResultsCount = (state) => state.routes.searchResultsCount
export const selectSelectedRouteId = (state) => state.routes.selectedRouteId
export const selectNoRoutesFound = (state) => state.routes.noRoutesFound
export const selectMapMarkers = (state) => state.routes.mapMarkers
export const selectNextLink = (state) => state.routes.nextRoutesLink
export const selectPrevLink = (state) => state.routes.prevRoutesLink
export const selectKmlLink = createSelector(
  selectSelectedRouteId,
  siteSelectors.selectSite,
  (id, site) => {
    if (id) {
      return `${site.canonical}routes/kml/${id}`
    }

    return null
  }
)



// WEBPACK FOOTER //
// ./src/services/routes/selectors.js